"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PictureInPicture_native_exports = {};
__export(PictureInPicture_native_exports, {
  PictureInPicture: () => PictureInPicture
});
module.exports = __toCommonJS(PictureInPicture_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_OneNativePictureInPictureNativeComponent = __toESM(require("../specs/OneNativePictureInPictureNativeComponent"), 1);
function PictureInPicture(param) {
  var { active = false, autoEnter = false, onActiveChange, ...props } = param;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativePictureInPictureNativeComponent.default, {
    ...props,
    active,
    autoEnter,
    onNativePictureInPictureChange: function onNativePictureInPictureChange(param2) {
      var { nativeEvent } = param2;
      return onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(nativeEvent.active);
    }
  });
}
//# sourceMappingURL=PictureInPicture.native.js.map
